import Model from '@/models/Model.js';

export default class SatisfierTemplate extends Model {
    static entity = 'satisfier_templates';

    static fields() {
        return {
            id: this.uid(null),
            time_period_template_id: this.attr(null),
            activity_template_id: this.attr(null),
            action: this.string(''),
            percent_of_time: this.number(null),
            requires_confirmation: this.boolean(false),
            order: this.number(null),

            ...super.fields(),

            time_period_template: this.belongsTo('time_period_templates', 'time_period_template_id'),
            activity_template: this.belongsTo('activity_templates', 'activity_template_id'),
        };
    }
}
